export default __webpack_public_path__ + "static/media/SwapPressed.0a0b4750.svg";